import React, { useEffect, useState } from "react";
import CustomTabs from "../../../../Custom/CustomTabs";
import { MdChevronRight } from "react-icons/md";
import AdvocateAnalysis from "./LegalAnalysisStep/AdvocateAnalysis";
import VAOAnalysis from "./LegalAnalysisStep/VAOAnalysis";
import RegisterOfficeAnalysis from "./LegalAnalysisStep/RegisterOfficeAnalysis";
import PhysicalInspection from "./LegalAnalysisStep/PhysicalInspection";
import OtherAnalysis from "./LegalAnalysisStep/OtherAnalysis";
import ProspectPropertyService from "../../../../Service/ProspectPropertyService";
import { userUid } from "../../../../../utils/storage";
import { ToastContainer } from "react-toastify";

const LegalAnalysisPage = ({ propertyId, setCurrentStep, isDropped , setProgressTrigger }) => {
  const [currentTab, setCurrentTab] = useState(1);
  const [analysisScore, setAnalysisScore] = useState(0);
  const [propertyData, setPropertyData] = useState(null);
  const [assignedUserData, setAssignedUserData] = useState({});
  const [triggerFetch, setTriggerFetch] = useState(false);

  const tabs = [
    { id: 1, name: "Advocate Analysis" },
    { id: 2, name: "VAO Analysis" },
    { id: 3, name: "SRO Analysis " },
    { id: 4, name: "Physical Inspection" },
    { id: 5, name: "General Analysis" },
  ];

  const handleMoveToNextStage = async () => {
    await ProspectPropertyService.moveToNextStage({
      propertyId: propertyId,
      stage: "Presentation Preparation",
      updatedBy: userUid,
    });
     setProgressTrigger((prev) => !prev); // trigger progress refetch
    setCurrentStep(3);
  };

  const fetchStageWiseData = async () => {
    try {
      const response = await ProspectPropertyService.getStageWiseProperties({
        propertyId: propertyId,
        stage: "Analysis",
      });
      const data = response.data?.data;
      if (data) {
        setPropertyData(data);
      }
    } catch (error) {
      console.error("Error fetching stage wise data:", error);
    }
  };

  useEffect(() => {
    fetchStageWiseData();
  }, [propertyId, triggerFetch]);

  const fetchAnalysisUsers = async () => {
    try {
      const response =
        await ProspectPropertyService.getAnalysisUsersList(propertyId);
      const data = response.data?.users;
      setAssignedUserData(data || {});
     
    } catch (error) {
      console.error("Error fetching analysis users:", error);
    }
  };

  useEffect(() => {
    fetchAnalysisUsers();
  }, []);

// 🔥 Calculate score based on flags

useEffect(() => {
  if (!propertyData) return;

  let score = 0;

  // Advocate Analysis → check Final Opinion
  if (
    propertyData.advocateAnalysisRecords?.finalOpinions &&
    propertyData.advocateAnalysisRecords.finalOpinions.length > 0
  ) {
    score += 40;
  }

  // VAO Analysis → check 3 flags in the first record
  const vao = propertyData.vaoAnalysisRecords?.records?.[0];
  if (vao?.fmaIsAllClear && vao?.aRecordIsAllClear && vao?.vaoAnalysisIsAllClear) {
    score += 15;
  }

  // SRO Analysis → check flag in the first record
  const sro = propertyData.sroAnalysisRecords?.records?.[0];
  if (sro?.sroAnalysisIsAllClear) {
    score += 15;
  }

  // Physical Inspection → check flag in the first record
  const physical = propertyData.physicalInspectionRecords?.records?.[0];
  if (physical?.physicalInspectionIsAllClear) {
    score += 15;
  }

  // General Analysis → check flag in the first record
  const general = propertyData.generalRecords?.records?.[0];
  if (general?.generalAnalysisIsAllClear) {
    score += 15;
  }

  setAnalysisScore(score);
}, [propertyData , triggerFetch]);



  return (
    <div className="bg-white rounded-[10px] p-6 h-[700px]">
     <ToastContainer/>
      <div className="flex items-center justify-between mb-4">
        {/* 🔥 Show calculated score */}
        <div className="text-orange-400 font-medium">
          Analysis score : {analysisScore}%
        </div>

        <button
          disabled={isDropped || currentTab !== 5}
          onClick={handleMoveToNextStage}
          className={`${
            currentTab === 5 && !isDropped
              ? "cursor-pointer text-white bg-customGreen"
              : "cursor-not-allowed bg-gray-400 text-white"
          } flex items-center rounded-full px-3 py-2  gap-2`}
        >
          <div className="text-sm"> Move to Next Stage </div>
          <MdChevronRight className="text-2xl" />
        </button>
      </div>

      <CustomTabs tabs={tabs} currentTab={currentTab} onTabChange={setCurrentTab} />

      {currentTab === 1 && (
        <div className="py-5 ">
          <AdvocateAnalysis
            propertyId={propertyId}
            setTriggerFetch={setTriggerFetch}
            assignedUserData={assignedUserData}
            propertyData={propertyData}
            isDropped={isDropped}
          />
        </div>
      )}

      {currentTab === 2 && (
        <div className="py-5">
          <VAOAnalysis
            propertyId={propertyId}
             setTriggerFetch={setTriggerFetch}
            assignedUserData={assignedUserData}
            propertyData={propertyData}
            isDropped={isDropped}
          />
        </div>
      )}

      {currentTab === 3 && (
        <div className="py-5">
          <RegisterOfficeAnalysis
            propertyId={propertyId}
             setTriggerFetch={setTriggerFetch}
            assignedUserData={assignedUserData}
            propertyData={propertyData}
            isDropped={isDropped}
          />
        </div>
      )}

      {currentTab === 4 && (
        <div className="py-5">
          <PhysicalInspection
            propertyId={propertyId}
             setTriggerFetch={setTriggerFetch}
            assignedUserData={assignedUserData}
            propertyData={propertyData}
            isDropped={isDropped}
          />
        </div>
      )}

      {currentTab === 5 && (
        <div className="py-5">
          <OtherAnalysis
            propertyId={propertyId}
            assignedUserData={assignedUserData}
             setTriggerFetch={setTriggerFetch}
            propertyData={propertyData}
            isDropped={isDropped}
          />
        </div>
      )}
    </div>
  );
};

export default LegalAnalysisPage;
